const groupBehaviorIds = {
    ShowGlobalSearch: 'ShowGlobalSearch',
    ShowGlobalSettings: 'ShowGlobalSettings',
    // Famly Store
    ShowFamlyStore: 'ShowFamlyStore',
};

export default groupBehaviorIds;
